import { ITextProcessorMiddleware } from 'components/RichTextEditor/processor/constants'

export const noLineBreaksMiddleware: ITextProcessorMiddleware = () => (next) => (action) => {
  if (action && action.type === 'insert') {
    action.text = action.text.replace(/(\r\n|\r|\n)/g, '')
  }
  return next(action)
}
